import { render, staticRenderFns } from "./DeviceAndLoginMethodProtector.vue?vue&type=template&id=655e412a&scoped=true"
import script from "./DeviceAndLoginMethodProtector.vue?vue&type=script&lang=ts"
export * from "./DeviceAndLoginMethodProtector.vue?vue&type=script&lang=ts"
import style0 from "./DeviceAndLoginMethodProtector.vue?vue&type=style&index=0&id=655e412a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655e412a",
  null
  
)

export default component.exports